import React, { useState, useEffect } from "react";
import Table from "../../../../common/table/Table.component";
import SideModal from "../../../../common/modal/SideModal.component";
import CreateIssueType from "../../../components/create-issue-type/createIssueType.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import IssueTypeClient from "../../../api-services/issue-type/issue-type-client";
import IssueTypeModel from "../../../models/IssueType";
import Select from "../../../../common/custom-select-list/CustomSelectList.component";
import { useTranslation } from "react-i18next";
import HandlingResponse from "../../../../common/handling-response/handlingResponse";

const IssueType = () => {
  const { t } = useTranslation();
  const tableName = "AP_ISSUE_TYPE";

  const client = new IssueTypeClient();

  const columns = [
    {
      Header: t("Id"),
      accessor: "id",
      disableFilters: false,
    },
    {
      Header: t("Name"),
      accessor: "name",
      disableFilters: false,
    },
    {
      Header: t("ExternalReference"),
      accessor: "extCode",
      disableFilters: false,
    },
    {
      Header: t("Description"),
      accessor: "description",
      disableFilters: false,
    },
    {
      Header: t("ShortDescription"),
      accessor: "shortDescription",
      disableFilters: false,
    },
    {
      Header: t("ForOg"),
      accessor: "forOg",
      Cell: ({ row }) => {
        return row.original.forOg && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      Header: t("ForReg"),
      accessor: "forReg",
      Cell: ({ row }) => {
        return row.original.forReg && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      Header: t("Active"),
      accessor: "active",
      Cell: ({ row }) => {
        return row.original.active && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      accessor: "edit",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <button
            className="btn btn-primary table-btn"
            onClick={() => onEditClick(row.original)}
          >
            <FontAwesomeIcon icon={solid("pen-to-square")} />
          </button>
        );
      },
    },
  ];

  const listOptions = [
    {
      label: t("All"),
      value: 1,
    },
    {
      label: t("ForOg"),
      value: 2,
    },
    {
      label: t("ForReg"),
      value: 3,
    },
    {
      label: t("ForOgAndReg"),
      value: 4,
    },
  ];

  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [rowData, setRowData] = useState(new IssueTypeModel());
  const [allIssueTypes, setAllIssueTypes] = useState([]);
  const [title, setTitle] = useState("");
  const [value, setValue] = useState(1);
  const [filtering, setFiltering] = useState(true);

  const showModal = () => setShow(true);
  const hideModal = () => {
    setShow(false);
    setRowData(new IssueTypeModel());
  };

  const getIssueTypes = async () => {
    let response = await client.getIssueType();
    let handledResponse = HandlingResponse(response);
    if (handledResponse !== "Error") setAllIssueTypes(handledResponse);
  };

  const handleAddingDataToTable = (childData) => {
    hideModal();
    if (!isEdit) {
      if (
        value == 1 ||
        (value == 2 && childData.forOg && !childData.forReg) ||
        (value == 3 && childData.forReg && !childData.forOg) ||
        (value == 4 && childData.forReg && childData.forOg)
      )
        setAllIssueTypes([...allIssueTypes, childData]);
    } else {
      if (
        value == 1 ||
        (value == 2 && childData.forOg && !childData.forReg) ||
        (value == 3 && childData.forReg && !childData.forOg) ||
        (value == 4 && childData.forReg && childData.forOg)
      ) {
        let allIssueTypesCopy = [...allIssueTypes];
        let index = allIssueTypesCopy.findIndex((x) => x.id === childData.id);
        allIssueTypesCopy[index] = childData;
        setAllIssueTypes(allIssueTypesCopy);
      } else {
        let allIssueTypesCopy = [...allIssueTypes];
        allIssueTypesCopy = allIssueTypesCopy.filter(
          (x) => x.id !== childData.id
        );
        setAllIssueTypes(allIssueTypesCopy);
      }
    }
  };

  useEffect(() => {
    getIssueTypes();
  }, []);

  const onCreateClick = () => {
    setIsEdit(false);
    setRowData(new IssueTypeModel());
    showModal();
    setTitle(t("CreatingIssueType"));
  };

  const onEditClick = (row) => {
    setIsEdit(true);
    setRowData(row);
    showModal();
    setTitle(t("EditingIssueType"));
  };

  const selectType = async (value) => {
    let response;
    if (value == 1) {
      response = await client.getIssueType();
    } else if (value == 2) {
      setFiltering(false);
      response = await client.getIssueTypesForOg(true, true);
    } else if (value == 3) {
      setFiltering(false);
      response = await client.getIssueTypesForReg(true, true);
    } else if (value == 4) {
      setFiltering(false);
      response = await client.getIssueTypesForOgAndReg(true);
    }
    let handledResponse = HandlingResponse(response);
    setFiltering(true);

    if (handledResponse !== "Error") setAllIssueTypes(handledResponse);
  };

  return (
    <>
      <div className="form-control">
        <div className="form-group">
          <h5 className="col-md-2">{t("IssueTypes")}</h5>
          <button className="btn btn-primary col-md-2" onClick={onCreateClick}>
            {t("AddIssueType")}
          </button>
        </div>
        <div className="form-group col-2">
          <label>{t("Type")}</label>
          <Select
            options={listOptions}
            onChange={(e) => {
              selectType(e.value);
              setValue(e.value);
            }}
            defaultValue={listOptions[0]}
          />
        </div>
        <Table
          columns={columns}
          data={allIssueTypes}
          rememberFilter={filtering}
          tableName={tableName}
          serverSide={false}
        />
      </div>

      <SideModal show={show} handleClose={hideModal} title={title}>
        <CreateIssueType
          row={rowData}
          isEdit={isEdit}
          handleCallback={handleAddingDataToTable}
        />
      </SideModal>
    </>
  );
};

export default IssueType;
